import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import pageContent, { contentPropTypes } from './index.content';
import { getNewPayeeDetails } from '../../states/addPayeeSuccess/selectors';
import { newPayeeDetailsPropTypes } from '../../states/addPayeeSuccess/propTypes';
import { Table } from '../../../sharedComponents';
import { getEditPayeeFlag } from '../../../managePayee/states/selectors';
import { goToManagePayeePage } from '../../../states/api/goToManagePayeePage';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { StatusBanner } from 'web-ui-components/lib/layout/content';

const mapState = (state) => ({
	newPayeeDetails: getNewPayeeDetails(state),
	isEditPayeeFlag: getEditPayeeFlag(state),
});

const mapDispatch = (dispatch) => ({
	goToManagePayeePage: () => dispatch(goToManagePayeePage()),
});

const AddPayeeSuccessPage = ({
	newPayeeDetails,
	content,
	handleRoute,
	isEditPayeeFlag,
	goToManagePayeePage,
	handleNowMakeAPaymentClick,
}) => {
	const primaryNavigationButton = (
		<NavigationButton.Primary
			data-test-id="navigation-handle-make-payment"
			onClick={handleNowMakeAPaymentClick}
			labelText={content.makePaymentsButtonLabel}
		/>
	);

	const secondaryNavigationButtons = [
		<NavigationButton.Secondary
			onClick={() => handleRoute('WEB-HOMEPAGE')}
			labelText={content.accountsButtonLabel}
			data-test-id="navigation-handle-go-to-account"
		/>,
		<NavigationButton.Secondary onClick={goToManagePayeePage} labelText={content.managePayeeButtonLabel} />,
	];

	return (
		<ServicingSection>
			<PageHeading>{isEditPayeeFlag ? content.editPayeeSuccessHeader : content.header}</PageHeading>

			<StatusBanner.Success>
				<StandardBody isFlush>
					{isEditPayeeFlag ? (
						<span>
							{content.editPayeeSuccessLeftLabel} <strong>{newPayeeDetails.name}</strong>
							{content.editPayeeSuccessRightLabel}
						</span>
					) : (
						<span>
							<strong>{newPayeeDetails.name}</strong> {content.alertMessage}
						</span>
					)}
				</StandardBody>
			</StatusBanner.Success>

			<Table content={content} newPayeeDetails={newPayeeDetails} />
			<div className="u-margin-top-4">
				<NavigationButtonGroup primaryButton={primaryNavigationButton} secondaryButtons={secondaryNavigationButtons} />
			</div>
		</ServicingSection>
	);
};

AddPayeeSuccessPage.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	newPayeeDetails: PropTypes.shape(newPayeeDetailsPropTypes).isRequired,
	handleRoute: PropTypes.func.isRequired,
	goToManagePayeePage: PropTypes.func.isRequired,
	handleNowMakeAPaymentClick: PropTypes.func.isRequired,
	isEditPayeeFlag: PropTypes.bool.isRequired,
};
export { AddPayeeSuccessPage };
export default compose(connect(mapState, mapDispatch), withContent({ content: pageContent }))(AddPayeeSuccessPage);
